import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subject, from } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TabService implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  readonly url$ = new BehaviorSubject<URL>(new URL('https://www.ozon.ru'));

  constructor() {

    // from(this.fetch())
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(([{ url }]) => this.url$.next(new URL(url)));

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private fetch() {
    // return this.browser.tabs.query({
    //   active: true,
    //   lastFocusedWindow: true
    // });
  }

}
